import { Component, Prop, Event, EventEmitter, h } from '@stencil/core';
import { Color } from '../../interface';
import { RadioData } from './radio-button-interface';

@Component({
  tag: 'lar-radio-button-content',
  styleUrl: 'radio-button.scss',
  shadow: false,
  scoped: true
})
export class RadioButtonContent {
   @Prop() color?: Color;
   @Prop() disabled?: boolean;
   @Prop() value: string;
   @Prop() radios: RadioData[] | string = [];
   @Prop() selected?: number | string;

   @Event() selectoption!: EventEmitter<number>;

   private getRadios(): RadioData[] {
     if (typeof this.radios === 'string') {
       try {
         return JSON.parse(this.radios);
       } catch (e) {
         return [];
       }
     }
     return Array.isArray(this.radios) ? this.radios : [];
   }

   private getSelected(): number | undefined {
     const selected = typeof this.selected === 'string' ? parseInt(this.selected, 10) : this.selected;
     return isNaN(selected as number) ? undefined : selected;
   }

   render() {
    const selectors = [];
    const radios = this.getRadios();
    const selected = this.getSelected();

    if (!radios || !Array.isArray(radios) || selected === undefined) {
      return selectors;
    }
    for (let i = 0; i < radios.length; i++) {
      if (!radios[i] || !radios[i].name) {
        continue;
      }
      const option = radios[i].name;
      const secondaryColor = this.color === 'dark' ? 'light' : 'dark';
      const color = (i === selected) ? this.color : secondaryColor;
      selectors.push(
        <lar-button
          expand="full"
          color={color}
          disabled={this.disabled}
          onClick={() => this.selectoption.emit(i)}
        >
          <lar-translate t={option} />
        </lar-button>
      );
    }
    return <div class="radios">{selectors}</div>;
  }
}